// Import model
import { StartIndividualContactAskSyntheaRequest } from '../models/StartIndividualContactAskSyntheaRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartIndividualContactAskSyntheaRequest - handles JSON serialization and deserialization with type validation
 */
export class StartIndividualContactAskSyntheaRequestSerializer {
  /**
   * Deserializes a JSON string into a StartIndividualContactAskSyntheaRequest instance
   */
  static deserialize(json: string): StartIndividualContactAskSyntheaRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartIndividualContactAskSyntheaRequest instance
   */
  static fromObject(obj: any): StartIndividualContactAskSyntheaRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartIndividualContactAskSyntheaRequest');
    }


    const instance: StartIndividualContactAskSyntheaRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartIndividualContactAskSyntheaRequest instances
   */
  static deserializeArray(json: string): StartIndividualContactAskSyntheaRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartIndividualContactAskSyntheaRequest instance to a JSON string
   */
  static serialize(instance: StartIndividualContactAskSyntheaRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartIndividualContactAskSyntheaRequest instance to a plain object
   */
  static toObject(instance: StartIndividualContactAskSyntheaRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartIndividualContactAskSyntheaRequest instances to a JSON string
   */
  static serializeArray(instances: StartIndividualContactAskSyntheaRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
